import { Box, LinkChevron, Text } from '@origin-digital/style-guide';

import React from 'react';
import analytics from '../../analytics';
import CheckCircleIcon from '../../components/Icons/CheckCircleIcon';

import { ThankYouProps } from './ThankYou.types';
import { connect } from 'react-redux';

class ThankYou extends React.Component<ThankYouProps> {
  componentDidMount() {
    analytics.pageLoad('thankyou');
  }

  render() {
    const { data, firstName, lastName } = this.props;

    return (
      <Box display={'flex'} flexWrap={true} justifyContent={'center'}>
        <Box maxWidth={360} alignSelf={'center'}>
          <Box marginBottom={4} display={'flex'} flexWrap={true} justifyContent={'center'}>
            <CheckCircleIcon size={33} color={'lightGreen'} />
          </Box>
          <Text
            align={'center'}
          >{`Thanks ${firstName} ${lastName}, ${data.content.successMessage}`}</Text>
          <Box marginTop={4}>
            <Text align={'center'}>{data.content.successMessagePart2}</Text>
          </Box>
          <Box
            marginTop={4}
            display={'flex'}
            flexWrap={true}
            justifyContent={'center'}
            cursor={'pointer'}
          >
            <LinkChevron href={data.content.solarLink.href} text={data.content.solarLink.text} />
          </Box>
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = state => {
  return {
    firstName: state.customer.firstName,
    lastName: state.customer.lastName
  };
};

export default connect(
  mapStateToProps,
  {}
)(ThankYou);
